import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import useApi from "../../../utils/api";
import { getErrorMessage } from "../../../utils/helpers/errors";

export const useWaiveTimeSheet = () => {
    const { authPut } = useApi();
    const { t } = useTranslation();

    const waiveMyMealPremium = useCallback(async (date, onSuccess, onFailure) => {
        try {
            await authPut(`/time-sheet/${date}/waive`);
            onSuccess?.();
        } catch (err) {
            getErrorMessage(err, t);
            onFailure?.();
        }
    }, [authPut, t]);

    const waiveMealPremium = useCallback(async (user, date, onSuccess, onFailure) => {
        try {
            await authPut(`/time-sheet/${user}/${date}/waive`);
            onSuccess?.();
        } catch (err) {
            getErrorMessage(err, t);
            onFailure?.();
        }
    }, [authPut, t]);

    return { waiveMyMealPremium, waiveMealPremium };
}
